import { useKleverWallet } from '../hooks/useKleverWallet';

interface WalletConnectProps {
  className?: string;
}

export function WalletConnect({ className = '' }: WalletConnectProps) {
  const { isConnected, isConnecting, address, connect, disconnect, isExtensionAvailable } =
    useKleverWallet();

  if (!isExtensionAvailable) {
    return (
      <a
        href="https://klever.io/en/wallet"
        target="_blank"
        rel="noopener noreferrer"
        className={`btn btn-outline ${className}`}
      >
        Install Klever Extension
      </a>
    );
  }

  if (isConnected && address) {
    return (
      <div className={`wallet-connected ${className}`}>
        <span className="wallet-address">
          {address.slice(0, 8)}...{address.slice(-6)}
        </span>
        <button onClick={disconnect} className="btn btn-sm btn-outline">
          Disconnect
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={connect}
      disabled={isConnecting}
      className={`btn btn-primary ${className}`}
    >
      {isConnecting ? 'Connecting...' : 'Connect Wallet'}
    </button>
  );
}
